import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function FormDiploma() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const payment_id = searchParams.get('payment_id') || '';
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '', phone: '', email: '', age: '',
        district: '', branch: '', college: '', year: '',
        experience: '', joining: ''
    });

    const districts = [
        'Araria', 'Arwal', 'Aurangabad', 'Banka', 'Begusarai',
        'Bhagalpur', 'Bhojpur', 'Buxar', 'Darbhanga', 'East Champaran',
        'Gaya', 'Gopalganj', 'Jamui', 'Jehanabad', 'Kaimur',
        'Katihar', 'Khagaria', 'Kishanganj', 'Lakhisarai', 'Madhepura',
        'Madhubani', 'Munger', 'Muzaffarpur', 'Nalanda', 'Nawada',
        'Patna', 'Purnia', 'Rohtas', 'Saharsa', 'Samastipur',
        'Saran', 'Sheikhpura', 'Sheohar', 'Sitamarhi', 'Siwan',
        'Supaul', 'Vaishali', 'West Champaran'
    ];

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await fetch('http://localhost:5000/api/forms/diploma', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...formData, payment_id }),
            });
            const data = await res.json();
            if (data.msg) {
                navigate('/success');
            } else {
                alert(data.error || 'Form submit nahi hua. Dobara try karo.');
            }
        } catch (err) {
            alert('Server error. Dobara try karo.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="bg-dark-300 min-h-screen py-16 px-4">
            <div className="max-w-2xl mx-auto">

                <div className="text-center mb-10">
                    <div className="text-5xl mb-4">📐</div>
                    <h1 className="font-display text-3xl font-bold text-white mb-2">
                        Diploma / B.Tech Registration Form
                    </h1>
                    <p className="text-gray-400">सभी details सही भरो — इसी से company contact करेगी</p>
                </div>

                <div className="bg-dark-200 border border-gray-800 rounded-3xl p-8">
                    <form onSubmit={handleSubmit} className="flex flex-col gap-5">

                        <h3 className="text-saffron-500 font-semibold text-sm uppercase tracking-widest">
                            Personal Details
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div>
                                <label className="text-gray-400 text-sm mb-2 block">पूरा नाम *</label>
                                <input
                                    type="text" name="name" required
                                    value={formData.name} onChange={handleChange}
                                    placeholder="Rahul Kumar"
                                    className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                                />
                            </div>
                            <div>
                                <label className="text-gray-400 text-sm mb-2 block">Phone Number *</label>
                                <input
                                    type="tel" name="phone" required
                                    value={formData.phone} onChange={handleChange}
                                    placeholder="98765 43210"
                                    className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div>
                                <label className="text-gray-400 text-sm mb-2 block">Email (optional)</label>
                                <input
                                    type="email" name="email"
                                    value={formData.email} onChange={handleChange}
                                    placeholder="rahul@gmail.com"
                                    className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                                />
                            </div>
                            <div>
                                <label className="text-gray-400 text-sm mb-2 block">Age *</label>
                                <input
                                    type="number" name="age" required min="14" max="40"
                                    value={formData.age} onChange={handleChange}
                                    placeholder="20"
                                    className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="text-gray-400 text-sm mb-2 block">District *</label>
                            <select
                                name="district" required
                                value={formData.district} onChange={handleChange}
                                className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition"
                            >
                                <option value="">-- District चुनो --</option>
                                {districts.map(d => (
                                    <option key={d} value={d}>{d}</option>
                                ))}
                            </select>
                        </div>

                        <h3 className="text-saffron-500 font-semibold text-sm uppercase tracking-widest mt-2">
                            Education Details
                        </h3>

                        <div>
                            <label className="text-gray-400 text-sm mb-2 block">Branch *</label>
                            <select
                                name="branch" required
                                value={formData.branch} onChange={handleChange}
                                className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition"
                            >
                                <option value="">-- Branch चुनो --</option>
                                <optgroup label="── Diploma ──">
                                    <option value="Diploma Mechanical">Diploma Mechanical</option>
                                    <option value="Diploma Electrical">Diploma Electrical</option>
                                    <option value="Diploma Electronics">Diploma Electronics</option>
                                </optgroup>
                                <optgroup label="── B.Tech ──">
                                    <option value="B.Tech Mechanical">B.Tech Mechanical</option>
                                    <option value="B.Tech Electrical">B.Tech Electrical</option>
                                    <option value="B.Tech EEE">B.Tech EEE</option>
                                </optgroup>
                            </select>
                        </div>

                        <div>
                            <label className="text-gray-400 text-sm mb-2 block">College Name *</label>
                            <input
                                type="text" name="college" required
                                value={formData.college} onChange={handleChange}
                                placeholder="Govt. Polytechnic / Engineering College, Patna"
                                className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                            />
                        </div>

                        <div>
                            <label className="text-gray-400 text-sm mb-2 block">Passing Year *</label>
                            <select
                                name="year" required
                                value={formData.year} onChange={handleChange}
                                className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition"
                            >
                                <option value="">-- Year चुनो --</option>
                                {[2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015].map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label className="text-gray-400 text-sm mb-2 block">Joining Availability *</label>
                            <select
                                name="joining"
                                required
                                value={formData.joining}
                                onChange={handleChange}
                                className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition"
                            >
                                <option value="">-- Joining select karo --</option>
                                <option value="immediate">Jaldi Join (Immediately)</option>
                                <option value="3days">3 Din Baad</option>
                                <option value="1week">1 Week Baad</option>
                            </select>
                        </div>
                        <div>
                            <label className="text-gray-400 text-sm mb-2 block">Experience *</label>
                            <select
                                name="experience" required
                                value={formData.experience} onChange={handleChange}
                                className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition"
                            >
                                <option value="">-- Select karo --</option>
                                <option value="fresher">Fresher</option>
                                <option value="experienced">Experienced</option>
                            </select>
                        </div>

                        <button
                            type="submit" disabled={loading}
                            className="w-full bg-saffron-500 hover:bg-saffron-600 disabled:opacity-70 text-white font-semibold py-4 rounded-full transition shadow-lg shadow-saffron-500/30 text-lg mt-2"
                        >
                            {loading ? 'Submitting...' : 'Form Submit करो →'}
                        </button>

                    </form>
                </div>

            </div>
        </main>
    );
}

export default FormDiploma;